import { Component, Vue } from 'vue-property-decorator';
import '@/app/app-error-handler';

@Component
export default class App extends Vue {

    public created() {
        const mainTag: any = document.querySelector('html') as HTMLElement;
        mainTag.style.zoom = this.$access.zoomValue;
    }
}
